import { DriverType } from '@clearcover/core-app-types';
import { Alert, Checkbox } from '@clearcover/atlas';
import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { Row } from 'Shared/components';
import { combineStrings, isPresent } from 'Shared/utils';
import { AddVehicleFormValues } from '.';
import styles from './styles.module.css';

type VehicleDriverAssignmentProps = {
  drivers: Array<DriverType>;
};

export const VehicleDriverAssignment: FC<VehicleDriverAssignmentProps> = ({
  drivers,
}) => {
  const { setFieldValue, values, errors } =
    useFormikContext<AddVehicleFormValues>();

  const handleSelectDriver = (d: string, isChecked: boolean) => {
    if (!isChecked) {
      setFieldValue(
        'assignedDrivers',
        values.assignedDrivers.filter((val) => val !== d)
      );
    } else {
      setFieldValue('assignedDrivers', [...values.assignedDrivers, d]);
    }
  };

  return (
    <div className={styles.section} data-testid="vehicle-driver-assignment">
      <h1>Driver Assignment</h1>
      <p>Which drivers will drive this vehicle most commonly?</p>
      <div className={styles.driverAssignmentSection}>
        {drivers.map(
          ({
            id,
            person: {
              name: { firstName, lastName, middleName },
              suffix,
            },
          }) => (
            <Row key={id}>
              <Checkbox
                name={`vehicleDrivers_${id}`}
                value={values.assignedDrivers.includes(id)}
                label={combineStrings([
                  firstName,
                  middleName,
                  lastName,
                  suffix,
                ])}
                onChange={(isChecked) => handleSelectDriver(id, isChecked)}
                error={!!errors.assignedDrivers}
              />
            </Row>
          )
        )}
      </div>

      {isPresent(errors.assignedDrivers) ? (
        <div className={styles.driverAssignmentSection}>
          <Alert
            type="error"
            message={
              Array.isArray(errors.assignedDrivers)
                ? errors.assignedDrivers[0]
                : errors.assignedDrivers
            }
          />
        </div>
      ) : null}
    </div>
  );
};
